import {ICollectionMapper} from '../Firestore/ICollectionMapper'
import {IOrder, Order} from './Order'
import moment from "moment";
import {OrderEntryMapper} from './OrderEntry/OrderEntryMapper'

export class OrderMapper implements ICollectionMapper<Order> {
  map(data: IOrder): Order {
    const order = new Order(data.number, data.type, data.orderedByUserId, data.orderedByCompanyId, data.orderedByCompanyName, data.assignedCompanyId)
    order.id = data.id

    order.status = data.status
    order.restaurantOrderId = data.restaurantOrderId
    order.originalOrderId = data.originalOrderId
    order.datePlaced = data.datePlaced ? moment(data.datePlaced).toDate() : undefined
    order.dateExpected = data.dateExpected ? moment(data.dateExpected).toDate() : undefined
    order.dateSubmittedForApproval = data.dateSubmittedForApproval ? moment(data.dateSubmittedForApproval).toDate() : undefined
    order.dateShipped = data.dateShipped ? moment(data.dateShipped).toDate() : undefined
    order.approvedByUserId = data.approvedByUserId
    order.readReceipt = data.readReceipt
    order.dateCheckedIn = data.dateCheckedIn ? moment(data.dateCheckedIn).toDate() : undefined
    order.vendorRepId = data.vendorRepId
    order.invoiceNumber = data.invoiceNumber

    order.orderEntries = (data.orderEntries || []).map(( new OrderEntryMapper ).map)

    return order
  }

  serialize(object: Order): IOrder {
    return JSON.parse(JSON.stringify(object))
  }
}
